import {BaseAnimation} from './BaseAnimation';

export class ScrollTopAnimation extends BaseAnimation {

    private fromValue:string|number|null=null;
    private toValue:string|number|null=null;

    public getClass():string {
        return 'scroll-top-animation';
    }

    public setCSS(e:JQuery<HTMLElement|SVGElement>,prop:string,value:string) {
        if (prop=='scroll-top' || prop=='scrollTop') {
            e.scrollTop(parseInt(value));
            return;
        }
        super.setCSS(e,prop,value);
    }

    public getCSS(e:JQuery,prop:string) {
        if (prop=='scroll-top') {
            if (e.css('--scroll-top')===undefined) {
                return this.animatedElement.scrollTop()+'px';
            }
            return this.getCalcValue(e.css('--scroll-top'))+'px';
        }
        return super.getCSS(e,prop);
    }

    public before() {
        let val=this.fromValue;
        if (val===null) {
            val=this.animatedElement.scrollTop()??0;
            this.from(val);
        }
        this.animatedElement.scrollTop(typeof val=='string'?parseInt(val):0);
    }

    public from(value:string|number) {
        this.fromValue=value;
        this.fromItem.css('--scroll-top',this.px(value));
        return this;
    }

    public to(value:string|number) {
        this.toValue=value;
        this.toItem.css('--scroll-top',this.px(value));
        return this;
    }

    private getCalcValue(value:string) {
        var old=this.element[0].style.height;
        this.animatedElement[0].style.height=value;
        var computed=parseInt(this.animatedElement.css('height'));
        this.animatedElement[0].style.height=old;
        return computed;
    }

}

export {};